import { Webhook } from "lucide-react"

import { Badge } from "@/components/ui/badge"
import { Button } from "@/components/ui/button"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"
import { ScrollArea } from "@/components/ui/scroll-area"

import { getEventLabel } from "./events"
interface EventsListProps {
  events: string[]
}
export const EventsList = ({ events }: EventsListProps) => {
  if (!events || events.length === 0) {
    return <span className="text-sm text-muted-foreground">-</span>
  }
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" className="h-8 gap-2">
          <Webhook className="h-4 w-4" />
          <span>
            {events.length} {events.length === 1 ? "evento" : "eventos"}
          </span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="max-w-96 p-0" align="center">
        <div className="border-b p-3">
          <h4 className="text-sm font-semibold">
            Eventos Configurados ({events.length})
          </h4>
        </div>
        <ScrollArea>
          <div className="max-h-[300px] space-y-2 p-2">
            {events.map((event) => (
              <div
                key={event}
                className="rounded-lg border bg-card p-2 transition-colors hover:bg-accent"
              >
                <Badge variant="outline" className="w-full justify-start">
                  {getEventLabel(event)}
                </Badge>
              </div>
            ))}
          </div>
        </ScrollArea>
      </PopoverContent>
    </Popover>
  )
}
